module.exports = __webpack_public_path__ + "img/open-15_6month01.56109d47.png";